import isNil from "lodash/isNil";
import type { ViewProps } from "tamagui";

import { isWeb } from "@/utils/platform.util";

type Cursor = ViewProps["cursor"];

interface CursorInputs {
  cursor?: Cursor;
  onPress?: unknown;
}

// eslint-disable-next-line sonarjs/function-return-type -- currently reported in SonarQube as unresolved
const getCursor = ({ cursor, onPress }: CursorInputs): Cursor => {
  // cursor only shown/used on web
  if (!isWeb()) return cursor;
  // cursor only shown if UI component has an onPress callback
  if (isNil(onPress)) return cursor;
  // always respect a provided cursor value, otherwise default to "pointer"
  return cursor ?? "pointer";
};

export { getCursor };
